angular.module("productData.components", []).component("productData", {
  templateUrl: "ng/components/richiestaPreventivo/productData/productData.view.html",
  bindings: {
    model: "=",
    exportProduct: "&",
    exportAmount: "&",
    exportValidityProductData: "&",
    initialTabIndex: "=",
    snapshot: '<',
    showAlert: "<"
  },

  controllerAs: "productDataCtrl",
  controller: function ProductData(
    $financialApiService,
    $q,
    Prodotto,
    $rootScope,
    $userService
  ) {
    var self = this;
    self.$rootScope = $rootScope;
    self.$onInit = function () {
      self.supportModel = {
        dropdown: {
          products: []
        },
        initialIndex: 0,
        testQuotaEsente: false
      }

      self.supportModel.initialIndex = self.initialTabIndex || 0;
      if (!self.snapshot) {

        getProducts().then(function (listProduct) {
          self.supportModel.dropdown.products = listProduct;
        })
      }
      self.showAlert = false;
      validationComponent();
    }

    var getProducts = function () {
      return $q(function (resolve, reject) {
        $financialApiService.currentDetail()
          .then(function (response) {
            console.log("response currentDetail", response);

            $userService
              .productConfigurationsRichPrev()
              .then(function (list) {
                var listProduct = list.domainList.map(function (element) {
                  return {
                    id: element.value,
                    description: element.name,
                    marcaMandatory: element.additionalProperty == "true" ? true : false
                  }
                })
                resolve(listProduct);
              })
              .catch(function (error) {
                reject(error);
              })
          })
          .catch(function (error) {
            console.log(error);
          })
      })
    }

    self.handleChange = function (property, value) {
      if (property === 'prodotto') {
        var isTargato = false;
        switch (value.id) {
          case "AVC":
          case "AVI":
          case "AVT":
          case "MOT":
            isTargato = true;
            break;
          default:
            break;
        }
        self.model.preventivo[property] = Prodotto.build(value);
        self.model.preventivo.prodotto.isTargato = isTargato;

        self.exportProduct({
          prodotto: self.model.preventivo.prodotto
        })
      } else if (property === 'amount') {
        self.model.preventivo.importo = value;

        self.exportAmount({
          amount: self.model.preventivo.importo
        })
      } else if (property === 'quotaEsente') {
        self.model.preventivo.prodotto.quotaEsente = value;
      }

      validationComponent();
    }

    var validationComponent = function () {
      var test = self.model.preventivo.prodotto.id && self.model.preventivo.importo;

      if (self.model.preventivo.prodotto.isTargato) {
        self.supportModel.testQuotaEsente = self.model.preventivo.prodotto.quotaEsente != null && self.model.preventivo.prodotto.quotaEsente != "" ||
          parseInt(self.model.preventivo.prodotto.quotaEsente) == 0;
      } else {
        self.supportModel.testQuotaEsente = true;
      }

      if (test && self.supportModel.testQuotaEsente) {
        self.exportValidityProductData({
          validity: true
        })
      } else {
        self.exportValidityProductData({
          validity: false
        })
      }
    }
  }
})